"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSafeContext = void 0;
var React = __importStar(require("react"));
var validateValue = function (name, value) {
    if (value === undefined) {
        throw new Error("value for " + name + " was not initialized. Make sure the Provider is set up.");
    }
    return value;
};
var safeConsumer = function (name, context) { return function (props) { return (React.createElement(context.Consumer, null, function (value) { return props.children(validateValue(name, value)); })); }; };
var safeProvider = function (context) { return function (props) { return (React.createElement(context.Provider, { value: props.value }, props.children)); }; };
/**
 * Creates an object that wraps a React Context and provides non-undefined values via the consumer and a custom hook. Also
 * prevents providing undefined as a value to the provider
 *
 * @export
 * @typeparam T The type of value the context should hold
 * @param {string} name The name of the context, used when no value is provided
 * @param {T} initialValue Optional initial value to store in the context
 * @returns {SafeContext<T>} The context wrapper, containing Consumer and Provider components, as well as a custom hook
 */
exports.createSafeContext = function (name, initialValue) {
    var context = React.createContext(initialValue);
    return {
        Consumer: safeConsumer(name, context),
        Provider: safeProvider(context),
        useValue: function () { return validateValue(name, React.useContext(context)); },
    };
};
